export default __webpack_public_path__ + "assets/3ef8abe4395e60e0856de0c798cd7fac.png";